import React, { useEffect, useRef, useContext } from "react";
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import { breakpoints } from "../stylesheets/variables";
import bgImg from '../assets/images/landing-bg.jpg';
import bgImgSm from '../assets/images/landing-bg-sm.jpg';
import bikeImg from '../assets/images/landing-bike.png';
import headingImg from '../assets/images/landing-heading.png';
import headingImgSm from '../assets/images/landing-heading-sm.png';
import overlay1Img from '../assets/images/overlay1.svg';
import overlay1ImgSm from '../assets/images/overlay1-sm.svg';
import overlay2Img from '../assets/images/overlay2.svg';
import overlay2ImgSm from '../assets/images/overlay2-sm.svg';
import AuthContext from '../contexts/AuthContext';

const Home = (props) => {
  const { isAuth } = useContext(AuthContext);
  const parallaxRef = useRef(null);
  useEffect(() => {
    const handleMouseMove = (event) => {
      if (parallaxRef.current) {
        parallaxRef.current.querySelectorAll(".parallax-item").forEach((shift) => {
          const position = shift.getAttribute("value");
          const x = (window.innerWidth - event.pageX * position) / 200;
          const y = (window.innerHeight - event.pageY * position) / 200;

          shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
        });
      }
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);
  
  return (
    <StyledHome className="home">
      <div ref={parallaxRef} className="parallax-wrap">
        <div className="bg">
          <img src={bgImg} alt="Matsutek background" className="show-sm" />
          <img src={bgImgSm} alt="Matsutek background" className="hide-sm" />
          <div className='bg-overlay1 parallax-item' value="8">
            <img src={overlay1Img} alt="Matsutek overlay" className="show-sm"/>
            <img src={overlay1ImgSm} alt="Matsutek overlay" className="hide-sm"/>
          </div>
          <div className='bg-overlay2 parallax-item' value="16">
            <img src={overlay2Img} alt="Matsutek overlay" className="show-sm"/>
            <img src={overlay2ImgSm} alt="Matsutek overlay" className="hide-sm"/>
          </div>
        </div>
        <div className="bike parallax-item" value="-2">
          <img src={bikeImg} alt="Matsutek e-bike" />
        </div>
        <div className="heading-group parallax-item show-sm" value="5">
          <img className="heading" src={headingImg} alt="Matsutek 永恆電動系統 無限能源循環 CHARGING TURBO" />
          {!isAuth && <div className="d-flex justify-content-center align-items-center pt-4">
            <Button variant="warning" size="lg" className="action-btn" onClick={() => window.location.href = '/register'}>
              立即註冊/登入
            </Button>
          </div>}
        </div>
        <div className="heading-group parallax-item hide-sm" value="2">
          <img className="heading" src={headingImgSm} alt="Matsutek 永恆電動系統 無限能源循環 CHARGING TURBO" />
          {!isAuth && <div className="d-flex justify-content-center align-items-center pt-3">
            <Button variant="warning" size="lg" className="action-btn" onClick={() => window.location.href = '/register'}>
              立即註冊/登入
            </Button>
          </div>}
        </div>
      </div>
    </StyledHome>
  );
};

const StyledHome = styled.main`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  .parallax-wrap {
    width: 100vw;
    height: 100vh;
    .parallax-item {
      position: absolute;
      transform: translateX(0px) translateY(0px);
      transition: transform 0.1s ease-out;
    }
  }
  img {
    display: block;
    width: 100%;
  }
  .bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: -1;
    > img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-overlay1 {
      position: absolute;
      width: 56%;
      left: -2%;
      bottom: -8%;
      ${breakpoints.down_md} {
        width: 60%;
        left: -14%;
        bottom: -10%;
      }
      ${breakpoints.down_sm} {
        width: 80%;
        left: -31%;
        bottom: 15%;
      }
    }
    .bg-overlay2 {
      position: absolute;
      width: 56%;
      left: 0%;
      bottom: -8%;
      ${breakpoints.down_md} {
        width: 60%;
        left: -9%;
        bottom: -10%;
      }
      ${breakpoints.down_sm} {
        width: 80%;
        left: -14%;
        bottom: 4%;
      }
    }
  }
  .bike{
    position: absolute;
    width: 36%;
    bottom: -6%;
    left: 2%;
    ${breakpoints.down_md} {
      width: 52%;
      bottom: -5%;
      left: 5%;
    }
    ${breakpoints.down_sm} {
      width: 66%;
      bottom: -2%;
      left: 21%;
    }
    ${breakpoints.down_xs} {
      width: 78%;
      bottom: -2%;
      left: 11%;
    }
    ${breakpoints.pad_pro} {
      width: 64%;
      bottom: -2%;
      left: 22%;
    }
    ${breakpoints.pad_md} {
      width: 64%;
      bottom: -2%;
      left: 22%;
    }
    ${breakpoints.pad} {
      width: 65%;
      bottom: -5%;
      left: 6%;
    }
    ${breakpoints.pad_sm} {
      width: 50%;
      bottom: -2%;
      left: 10%;
    }
  }
  .heading-group {
    width: 32%;
    top: 30%;
    left: 37%;
    ${breakpoints.down_md} {
      width: 45%;
      top: 25%;
      left: 27%;
    }
    ${breakpoints.down_sm} {
      width: 60%;
      top: 20%;
      left: 20%;
    }
    ${breakpoints.pad_pro} {
      width: 60%;
      top: 15%;
      left: 20%;
    }
    ${breakpoints.pad_md} {
      width: 50%;
      top: 25%;
      left: 25%;
    }
    ${breakpoints.pad_sm} {
      width: 52%;
      top: 15%;
      left: 24%;
    }
    
  }
  .show-sm {
    display: block;
    object-position: right top;
    ${breakpoints.down_sm} {
      display: none;
    }
  }
  .hide-sm {
    display: none;
    object-position: center bottom;
    ${breakpoints.down_sm} {
      display: block;
    }
  }
  .action-btn{
    font-size: 1.25vw;
    padding: 1vw 2.25vw;
    color: #FFF;
    ${breakpoints.down_lg} {
      font-size: 1.25rem;
      padding: 12px;
      min-width: 280px;
    }
    ${breakpoints.down_md} {
      min-width: 240px;
    }
    ${breakpoints.down_sm} {
      width: 80%;
      min-width: initial;
      margin: 0 auto;
      padding-left: 0;
      padding-right: 0;
    }
    ${breakpoints.down_xs} {
      font-size: 1rem;
      min-width: 180px;
      padding: 8px;
      width: 100%;
      margin-top: 1rem;
    }
  }
`;

export default Home;
